export default function PageHeader({ title, subtitle, action, testId }) {
  return (
    <div data-testid={testId} className="flex items-start justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-[#0F172A]">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-gray-500 mt-1 max-w-2xl">{subtitle}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
